module.exports = {
	"data": {
		"postBySlug": {
			"html": "<h2 id=\"start-components\"><a href=\"#start-components\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Start components</h2>\n<p>For running through the steps of the tutorial It is supposed to have a working Kubernetes cluster which serves web applications from an IP address of your host machine.</p>\n<p>At the moment the only component that needs to be deployed outside of the cluster is the GeoAvalanche server which is not yet Docker-ready. We can compile it and deploy into an application container like <a href=\"https://tomcat.apache.org/\">Tomcat</a>.</p>\n<h3 id=\"preliminary-checks\"><a href=\"#preliminary-checks\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Preliminary checks</h3>\n<p>If you are running <a href=\"https://kubernetes.io/docs/setup/minikube/\">minikube</a> for a local instance of kubernetes cluster then following these steps:</p>\n<ol>\n<li>Start minikube</li>\n</ol>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-shell\"><code>minikube start</code></pre>\n      </div>\n<ol start=\"2\">\n<li>Check the status</li>\n</ol>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-shell\"><code>minikube status</code></pre>\n      </div>\n<p>the result is something like</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-shell\"><code>minikube: Running\ncluster: Running\nkubectl: Correctly Configured: pointing to minikube-vm at 192.168.99.100</code></pre>\n      </div>\n<p>our host IP address will be <code>192.168.99.100</code></p>\n<ol start=\"3\">\n<li>Configure the shell for Docker</li>\n</ol>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-shell\"><code>eval $(minikube docker-env)</code></pre>\n      </div>\n<h3 id=\"postgis\"><a href=\"#postgis\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>PostGIS</h3>\n<p>At this point starting an instance of PostGIS is quite simple with a <code>docker</code> command and some configuration parameters for it:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-shell\"><code>docker run -p 5432:5432 --name caaml-db -e POSTGRES_PASSWORD=geonode -e GEONODE_DATABASE=geonode -e GEONODE_DATABASE_PASSWORD=geonode -e GEONODE_GEODATABASE=caaml_data -e GEONODE_GEODATABASE_PASSWORD=geonode -d geonode/postgis</code></pre>\n      </div>\n<p>Important notes are:</p>\n<ul>\n<li>The server will be available on port <code>5432</code> of the host</li>\n<li>The master use will be <code>postgres</code> with password <code>geonode</code></li>\n<li>Our spatial database for CAAML is named <code>caaml_data</code></li>\n</ul>\n<h3 id=\"pgadmin4\"><a href=\"#pgadmin4\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>PGAdmin4</h3>\n<p>Let's start also an utility to work with the previously created database <code>caaml_data</code>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-bash\"><code>docker run -p 54321:80 --name caaml-pgadmin4 -e PGADMIN_DEFAULT_PASSWORD<span class=\"token operator\">=</span>geonode -e PGADMIN_DEFAULT_EMAIL<span class=\"token operator\">=</span>admin@caaml.org -d dpage/pgadmin4\n</code></pre>\n      </div>\n<p>Important notes:</p>\n<ul>\n<li>The PGAdmin4 application will be available on port <code>54321</code> of the host</li>\n<li>Login to the console can be done with username <code>admin@caaml.org</code> and password <code>geonode</code></li>\n</ul>\n<h4 id=\"check-the-connection\"><a href=\"#check-the-connection\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Check the connection</h4>\n<p>Login to the console:</p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 53.125%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABBUlEQVQoz6WR3U6DMBiGuf8L8QI2NZhMjWfGzf2o6EAkiBt2dSPdyk9ZgdfCxAMz1LA3edKDL+/TL62WpimSJEEYRooQjLHqFEIgz/NGpJRYx0J1Q8ScY81jRBsOrSgK7KMsUUoruCqUl9SUs6aehoaUQ6E2KCmy4ptM7mRN+VU48ScY+AOMyFgxwvB9iPuF0V7Ys3roGB10jS50U8fx9AQX9mV7oUMdWOQZJrHhBR7cwMWMzdoLq3fLUfFzVmcrMwSbCDxJIbbyD+EX2PObdV78Jcw3ijvHx3zJmoX/jX7zCJcEOOs/YfpKDheeXj/AW6ygK6FLVocLr8YW7PkHjs5vQVmIT/nTWRNaIgSGAAAAAElFTkSuQmCC'); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"login pgadmin4\"\n        title=\"\"\n        src=\"/static/95559cad3ac7c6f6a2cb32eb1f04342b-44d6a.png\"\n        srcset=\"/static/95559cad3ac7c6f6a2cb32eb1f04342b-f4799.png 173w,\n/static/95559cad3ac7c6f6a2cb32eb1f04342b-b3b1d.png 345w,\n/static/95559cad3ac7c6f6a2cb32eb1f04342b-44d6a.png 690w,\n/static/95559cad3ac7c6f6a2cb32eb1f04342b-bc0f7.png 1035w,\n/static/95559cad3ac7c6f6a2cb32eb1f04342b-b50e5.png 1380w,\n/static/95559cad3ac7c6f6a2cb32eb1f04342b-0ed32.png 2070w,\n/static/95559cad3ac7c6f6a2cb32eb1f04342b-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>You can then add a new connection by right-clicking on <code>Servers</code>, then choicing <code>Create</code> and <code>Server</code>:</p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 110.5675146771037%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAACXBIWXMAAAsSAAALEgHS3X78AAAB30lEQVQ4y81UWUsbURidP+urgvVJKkogtL5YCjZVLChtI9q8SZXiQhFcUjXCoE2Mmcxk0mTMvu/bcc6FgSRFzKgPHjjc2Tj3fOf75krLP32Y/ubFm9UTjH85xqS5jrkObdPhPsLathfSj4NLzHv+4L3nDI7Nczg9F5gyRSdWDm1xfuMI7l+moOy/hc8fhvbvDvF4HNFoFKlUCn5Fh6JG4PsbxqX5/vpWg3yj4sK8vwqq4rth6roOKZfLIZ1Oox/NZhPFYhGlUkmwXC6j0+k8ylqtBimTySAQCCASiUDTNBQKBbRaLXAjvsvn80J0ZEEKVKvVAYcUrNfrI4n8J0gHFO1HpVJBLBYTwnZIYxLzU1VVBMpg2+22KJHXhmGg1+uNTCGYzWYRCoVEftyF6Ha7tsslGZMQtNrOzhJ0SMcs246gcEgR2rWcWWPTaDTEajtDjoflkF0iaJ3P+ZFth5w1ljc82E8BqxJdtjpMV8/BgGA/ODpP6bIomf/pMOwO9EBTrAz7y31xh8/K8PULWidtIpEQTCaTD9K9L8O5cYqv67tQP39C+OMH6G4XsmfLyBwvwJC3IPGkCQaDUBRFHLL8fx/iouc3ZlZ2sLS0iat3TsiOOQRcTtztzcLYfQvd+x33n9l1fW4moNUAAAAASUVORK5CYII='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"connection pgadmin\"\n        title=\"\"\n        src=\"/static/d51110d016ec3281bef0d136707e2e57-44d6a.png\"\n        srcset=\"/static/d51110d016ec3281bef0d136707e2e57-f4799.png 173w,\n/static/d51110d016ec3281bef0d136707e2e57-b3b1d.png 345w,\n/static/d51110d016ec3281bef0d136707e2e57-44d6a.png 690w,\n/static/d51110d016ec3281bef0d136707e2e57-b4668.png 1022w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Fill the connection form with the values for accessing the database and give it a name i.e. <code>caaml_tutorial</code> then click the <code>Save</code> button.</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-bash\"><code><span class=\"token comment\" spellcheck=\"true\"># connection parameters</span>\nHostname: 192.168.99.100\nPort: 5432\nUsername: postgres\nPassword: geonode\n</code></pre>\n      </div>\n<p>We should see something similar to this dashboard:</p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 50.78125%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABvUlEQVQoz22Q60/acBSG++/uw5TCkkoGM/wZ+7DMuBmTabJ4yVRcTLZhgojcxFIplFXGRZiKzJZyfdZW10zgJE9+p29P3pz3CC9eLrLweplXUpBgMEgoFCIcDiMtLSH6Ayz6fCz4RHyiaPd+GxFR9BMIBDzCwTdEIhEkSUKoX99QqdYxTYvhcIhhmHxJlNk+KbN5XGIjVmTDfj/FVNZjJXJai4OUTjSt8zmu/UeZb/kqgtWzuNJVOp0OTo1GI+SyStfoMx6PZ+j1eiQuFFod85l+b2a5fUghOFs5Q//KMTRNc66Zg2U9JpnWuz2Zu4c0AlM1GAw5zFTZSV555PQbO06N3USFnVPdJVlqES9es/s0s3WicixXZw2dDS8rGrX2vds7OBtVmr+otTpu76ay7tBbdW67hqdZ1p9ZQ+dHv99nMpl4OKaGYTy/Zf+3e6ppbW7kr9kq++mn2G7En4+vdwadrVN1RosV9HmGAzRNQ7lUycsFMnmZ3EWBbL7gfiuK4lEsFmk0GjSbTZd2uz3f8O12nNVoirXDNCv7Kd7vndkkWT04YyWa4YOtv7O1j/bM+lGOtaNzNr/L/DjX+QvFe8ecIpXczgAAAABJRU5ErkJggg=='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"database pgadmin\"\n        title=\"\"\n        src=\"/static/c4002a47c6518482173f4379e74d3f68-44d6a.png\"\n        srcset=\"/static/c4002a47c6518482173f4379e74d3f68-f4799.png 173w,\n/static/c4002a47c6518482173f4379e74d3f68-b3b1d.png 345w,\n/static/c4002a47c6518482173f4379e74d3f68-44d6a.png 690w,\n/static/c4002a47c6518482173f4379e74d3f68-bc0f7.png 1035w,\n/static/c4002a47c6518482173f4379e74d3f68-b50e5.png 1380w,\n/static/c4002a47c6518482173f4379e74d3f68-0ed32.png 2070w,\n/static/c4002a47c6518482173f4379e74d3f68-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>",
			"timeToRead": 2,
			"excerpt": "Start components For running through the steps of the tutorial It is supposed to have a working Kubernetes cluster which serves web...",
			"frontmatter": {
				"title": "Start the environment",
				"cover": null,
				"date": null,
				"category": null,
				"tags": null
			}
		},
		"tableOfContents": {
			"chapters": [
				{
					"title": "1. Introduction",
					"entries": null,
					"chapters": [
						{
							"title": "1.1 OGC Standards",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_ogc.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-ogc"
											},
											"frontmatter": {
												"title": "Introduction to OGC"
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "1.1.1 Web Mapping Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wms.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wms"
													},
													"frontmatter": {
														"title": "Introduction to WMS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wms.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wms-examples"
													},
													"frontmatter": {
														"title": "WMS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.2 Web Feature Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wfs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wfs"
													},
													"frontmatter": {
														"title": "Introduction to WFS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wfs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wfs-examples"
													},
													"frontmatter": {
														"title": "WFS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.3 Web Coverage Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wcs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wcs"
													},
													"frontmatter": {
														"title": "Introduction to WCS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wcs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wcs-examples"
													},
													"frontmatter": {
														"title": "WCS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.4 Web Processing Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wps.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wps"
													},
													"frontmatter": {
														"title": "Introduction to WPS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wps.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wps-examples"
													},
													"frontmatter": {
														"title": "WPS Examples"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "1.2 CAAML",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_caaml.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-caaml"
											},
											"frontmatter": {
												"title": "Introduction to CAAML"
											}
										}
									}
								}
							],
							"chapters": null
						},
						{
							"title": "1.3 INSPIRE",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_inspire.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-inspire"
											},
											"frontmatter": {
												"title": "Introduction to INSPIRE"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "2. Standards in action",
					"entries": null,
					"chapters": [
						{
							"title": "2.1 Prepare data and toolkit",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_data_tools.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/data-and-geospatial-tools"
											},
											"frontmatter": {
												"title": "Data and geospatial tools"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/bootstrap_servers.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/start-the-environment"
											},
											"frontmatter": {
												"title": "Start the environment"
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "2.1.1 Manage the data",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/load-data"
													},
													"frontmatter": {
														"title": "Load Data"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/clean_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/clean-data"
													},
													"frontmatter": {
														"title": "Clean Data"
													}
												}
											}
										}
									]
								},
								{
									"title": "2.1.2 Design the CAAML schema",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/er_design.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/caaml-model-design"
													},
													"frontmatter": {
														"title": "CAAML model design"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/populate_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/populate-region"
													},
													"frontmatter": {
														"title": "Populate Region"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "2.2 Build CAAML with GeoAvalanche",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/caaml_hale.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/configure-the-application-schema-for-caaml"
											},
											"frontmatter": {
												"title": "Configure the application schema for CAAML"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_configuration.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/push-the-configuration-to-geo-avalanche"
											},
											"frontmatter": {
												"title": "Push the configuration to GeoAvalanche"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/query_data.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/query-our-region-features"
											},
											"frontmatter": {
												"title": "Query our Region features"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "3. Main Chapter",
					"entries": [
						{
							"entry": {
								"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/lesson_six.md absPath of file",
								"childMarkdownRemark": {
									"fields": {
										"slug": "/lesson-six"
									},
									"frontmatter": {
										"title": "Lesson Six"
									}
								}
							}
						}
					],
					"chapters": null
				}
			]
		}
	},
	"pathContext": {
		"slug": "/start-the-environment"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/start-the-environment.json
// module id = 425
// module chunks = 105755850038661